export default __webpack_public_path__ + "static/media/image_16.5c9bc281.jpg";